/* tslint:disable */
/* eslint-disable */
/**
 * Document Simulation API
 * API for managing document simulations and contractualization strategies
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileTypeEnum } from './FileTypeEnum';
import {
    FileTypeEnumFromJSON,
    FileTypeEnumFromJSONTyped,
    FileTypeEnumToJSON,
    FileTypeEnumToJSONTyped,
} from './FileTypeEnum';

/**
 * 
 * @export
 * @interface DocumentContractuelProduitDto
 */
export interface DocumentContractuelProduitDto {
    /**
     * 
     * @type {FileTypeEnum}
     * @memberof DocumentContractuelProduitDto
     */
    fileType: FileTypeEnum;
    /**
     * Name of the FileType enum member (e.g. Notice, Ipid)
     * @type {string}
     * @memberof DocumentContractuelProduitDto
     */
    fileTypeCode: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentContractuelProduitDto
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentContractuelProduitDto
     */
    storedFileId: string;
    /**
     * True for a document of the collective (group) contract, false for the individual one
     * @type {boolean}
     * @memberof DocumentContractuelProduitDto
     */
    isGroup: boolean;
}



/**
 * Check if a given object implements the DocumentContractuelProduitDto interface.
 */
export function instanceOfDocumentContractuelProduitDto(value: object): value is DocumentContractuelProduitDto {
    if (!('fileType' in value) || value['fileType'] === undefined) return false;
    if (!('fileTypeCode' in value) || value['fileTypeCode'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('storedFileId' in value) || value['storedFileId'] === undefined) return false;
    if (!('isGroup' in value) || value['isGroup'] === undefined) return false;
    return true;
}

export function DocumentContractuelProduitDtoFromJSON(json: any): DocumentContractuelProduitDto {
    return DocumentContractuelProduitDtoFromJSONTyped(json, false);
}

export function DocumentContractuelProduitDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentContractuelProduitDto {
    if (json == null) {
        return json;
    }
    return {
        
        'fileType': FileTypeEnumFromJSON(json['fileType']),
        'fileTypeCode': json['fileTypeCode'],
        'label': json['label'],
        'storedFileId': json['storedFileId'],
        'isGroup': json['isGroup'],
    };
}

export function DocumentContractuelProduitDtoToJSON(json: any): DocumentContractuelProduitDto {
    return DocumentContractuelProduitDtoToJSONTyped(json, false);
}

export function DocumentContractuelProduitDtoToJSONTyped(value?: DocumentContractuelProduitDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileType': FileTypeEnumToJSON(value['fileType']),
        'fileTypeCode': value['fileTypeCode'],
        'label': value['label'],
        'storedFileId': value['storedFileId'],
        'isGroup': value['isGroup'],
    };
}

